var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import selectn from "selectn";

import Headline from "../Headline";
import StoryBody from "../StoryBody";
import PrimaryImage from "../PrimaryImage";
import styles from "./StoryContent.css";

var StoryContent = function (_Component) {
  _inherits(StoryContent, _Component);

  function StoryContent() {
    _classCallCheck(this, StoryContent);

    return _possibleConstructorReturn(this, (StoryContent.__proto__ || Object.getPrototypeOf(StoryContent)).apply(this, arguments));
  }

  _createClass(StoryContent, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          isSummary = _props.isSummary,
          storyType = _props.storyType,
          permalinkId = _props.permalinkId,
          index = _props.index;

      if (!story) return null;
      var isFeatured = story.is_featured && !isSummary;

      var textOverStory = selectn("rubric.name", story) || isFeatured && "Featured";
      var textOverColor = selectn("rubric.hex_color", story);

      return React.createElement(
        "div",
        null,
        textOverStory && React.createElement(
          "div",
          { className: styles.featured, style: textOverColor && { color: "#" + textOverColor } },
          textOverStory
        ),
        story.headline && React.createElement(Headline, { headline: story.headline, permalink: story.permalink, noLink: !isSummary }),
        !isSummary && React.createElement(PrimaryImage, { image: story.primary_image, lazyload: index !== 0 }),
        React.createElement(StoryBody, { story: story, storyType: storyType, permalinkId: permalinkId })
      );
    }
  }]);

  return StoryContent;
}(Component);

StoryContent.propTypes = {
  story: PropTypes.object,
  storyType: PropTypes.oneOf(["newsletter"]),
  isSummary: PropTypes.bool,
  permalinkId: PropTypes.string
};

export default StoryContent;


// WEBPACK FOOTER //
// ./src/components/Library/StoryContent/StoryContent.js